import axios, { type AxiosResponse } from 'axios';
import { logger } from '@trading-utils/logger';
import { processBackendError } from '@/utils/error.utils';

import { apiRoutes } from '@/config/apiRoutes';

import i18n from '@/i18n/config';

import type { User, RegisterUserPayload } from '@/interfaces';

export const getCurrentUser = async (): Promise<User> => {
  const url = `${apiRoutes.base}${apiRoutes.auth.base}${apiRoutes.auth.cognito}`;

  try {
    const response: AxiosResponse<User> = await axios.get(url);

    logger.info(`Retrieved user ${response.data.email} info`);

    return response.data;
  } catch (error) {
    logger.error('Error retrieving current user', { url, error });
    throw processBackendError(error, i18n.t('errors.auth.errorGetCurrentUser'));
  }
};

export const registerUser = async (payload: RegisterUserPayload): Promise<void> => {
  const url = `${apiRoutes.base}${apiRoutes.auth.base}${apiRoutes.auth.register}`;

  try {
    const response: AxiosResponse<void> = await axios.post(url, payload);

    logger.info('User registered successfully');

    return response.data;
  } catch (error) {
    logger.error('Error registering user', { url, error });
    throw processBackendError(error, i18n.t('errors.auth.errorRegisterUser'));
  }
};
